module.exports = __webpack_public_path__ + "static/media/joe-result.5c011759.png";